// Compiles but fails in webpack>??
//import { BusinessObjectAssembler } from '@iotv/datamodel'
import { BusinessObjectAssembler } from '@iotv/datamodel';
const Assembler = new BusinessObjectAssembler();
export default Assembler;
